import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { Input, Label, Link } from "../odc-ui";
import { flash } from "../utilities/flash";

function NewSession() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState("");

  function handleSubmit(e) {
    e.preventDefault();

    $.ajax({
      url: "/users/sign_in",
      method: "POST",
      data: {
        user: {
          email,
          password,
          remember_me: rememberMe ? 1 : 0,
        },
      },
      success: () => {
        window.location.href = "/";
      },
      error: () => {
        flash("error", "Invalid email or password.");
      },
    });
  }

  return (
    <div className="component-new-session">
      <h2>Log In</h2>

      <form className="standard-form" id="new_user" onSubmit={handleSubmit}>
        <div className="field">
          <Label htmlFor="user_email">
            Email
            <Input
              autoFocus="autofocus"
              autoComplete="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              name="user[email]"
              id="user_email"
            />
          </Label>
        </div>

        <div className="field">
          <Label htmlFor="user_password">
            Password
            <Input
              autoComplete="current-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              name="user[password]"
              id="user_password"
            />
          </Label>
        </div>

        <Link
          className="dark-link forgot-password-link"
          href={`/users/password/new?email=${email}`}
        >
          Forgot your password?
        </Link>
        <br />

        <div className="field">
          <Input
            name="user[remember_me]"
            type="checkbox"
            value="0"
            onChange={() => setRememberMe((rememberMe) => !rememberMe)}
            autoComplete="off"
          />

          <Label className="checkbox-label" htmlFor="user_remember_me">
            Stay logged in
          </Label>
        </div>

        <div className="actions">
          <Input
            type="submit"
            name="commit"
            value="Log In"
            className="btn btn-primary"
            data-disable-with="Log In"
            onClick={handleSubmit}
          />
        </div>

        <div className="auth-links-container">
          <div className="auth-link-container">
            Not a member?{" "}
            <Link href="/users/sign_up" className="auth-link">
              Sign Up
            </Link>
          </div>
        </div>
      </form>
      <div className="learn-more-container">
        Discover how Healthcoin® can empower your wellness journey.{" "}
        <Link href="https://ottawadermcentre.com/healthcoin/">
          Learn more here!
        </Link>
      </div>
    </div>
  );
}

document.addEventListener("DOMContentLoaded", () => {
  const mountPoint = document.getElementById("new-session-mount-point");

  if (mountPoint) {
    ReactDOM.createRoot(mountPoint).render(<NewSession />);
  }
});
